export default __webpack_public_path__ + "static/media/cern-semibold.80bd9675.ttf";